import gsap from 'gsap';

function init() {
  const loaderEl = document.querySelector('#loader');
  if (!loaderEl) {
    return;
  }
  const dots = Array.from(loaderEl.querySelectorAll('span'));
  gsap.set(loaderEl, {display: 'flex', opacity: 1});
  gsap.killTweensOf(dots);
  const tl = gsap.timeline({repeat: -1, repeatDelay: 0.5});
  return tl.fromTo(dots, {
    opacity: 0,
    y: 5,
  }, {
    opacity: 1,
    y: 0,
    duration: 0.2,
    stagger: 0.1,
    ease: 'back.out(2)'
  });
}

function stop() {
  const loaderEl = document.querySelector('#loader');
  if (!loaderEl) {
    return;
  }
  const dots = Array.from(loaderEl.querySelectorAll('span'));
  const tl = gsap.timeline();
  return tl.to(loaderEl, {
    display: 'none',
    opacity: 0,
    duration: 0.2
  })
  .call(() => {
    return gsap.killTweensOf(dots);
  });
}

const loader = {
  init: init,
  stop: stop
}

export default loader;
